import { Reveal, Overline } from "./Reveal";
import { Gift, UserPlus, BadgePercent } from "lucide-react";

const scrollTo = (id) => document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });

const steps = [
  { icon: UserPlus, title: "Refer a Friend", desc: "Tell someone about Howell Transformations and have them mention your name when they apply." },
  { icon: BadgePercent, title: "They Start Coaching", desc: "When your referral signs up for a coaching program, your reward is unlocked." },
  { icon: Gift, title: "You Get Rewarded", desc: "Earn account credit or a discount on your own coaching as a thank-you." },
];

export const Referral = () => {
  return (
    <section id="referral" className="relative py-24 md:py-32 bg-[#0A0A0A]">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <Reveal className="max-w-2xl">
          <Overline>Referral Program</Overline>
          <h2 className="font-display font-semibold uppercase tracking-tight text-white text-3xl sm:text-4xl lg:text-5xl mt-4 leading-tight">
            Share The Grind. Get Rewarded.
          </h2>
          <p className="mt-5 text-[#A3A3A3] leading-relaxed">
            Love your results? Send your friends my way. When someone you refer becomes a coaching
            client, you earn rewards or discounts on your own coaching. It&rsquo;s my way of saying thank you
            for helping others start their transformation.
          </p>
        </Reveal>

        <div className="mt-14 grid grid-cols-1 md:grid-cols-3 gap-6">
          {steps.map((s, i) => (
            <Reveal key={s.title} delay={i * 0.08}>
              <div data-testid={`referral-step-${i}`} className="h-full bg-[#141414] border border-[#262626] p-8">
                <div className="w-12 h-12 flex items-center justify-center bg-[#0055FF]/10 border border-[#0055FF]/30 mb-6">
                  <s.icon size={22} className="text-[#0055FF]" />
                </div>
                <div className="text-xs uppercase tracking-widest text-[#0055FF] font-bold">Step {i + 1}</div>
                <h3 className="font-display font-semibold text-xl text-white mt-2">{s.title}</h3>
                <p className="mt-3 text-sm text-[#A3A3A3] leading-relaxed">{s.desc}</p>
              </div>
            </Reveal>
          ))}
        </div>

        <Reveal delay={0.2}>
          <button
            data-testid="referral-cta"
            onClick={() => scrollTo("apply")}
            className="mt-10 bg-[#0055FF] text-white hover:bg-[#3377FF] transition-colors font-bold px-8 py-4 uppercase tracking-wide"
          >
            Apply & Start Referring
          </button>
        </Reveal>
      </div>
    </section>
  );
};
